import { WebApiAdaptor,DataUtil } from '@syncfusion/ej2-data';


export class CustomWebApiAdaptor extends WebApiAdaptor {  
    processResponse() {
        //debugger;
        //calling base class processResponse function
        //var data;
        var finalData;
        var lastData;
        const original = super.processResponse.apply(this, arguments);
        /* data = original.data; */


        /* original.data.map(key => {
            if (key.markdate)  {
                key.markdate.replaceAll("-","/");
                //var dateval = new Date(key.markdate)
                //var dateObject = new Date( dateval.getTime()+ dateval.getTimezoneOffset()*60000)
                var dateObject = new Date(key.markdate)//.toUTCString()
                key.markdate = dateObject;
            }
            return true;
        }) */

        finalData = JSON.stringify(original.data);

        lastData = DataUtil.parse.parseJson(finalData);
        let filterSearch;
        //filterSearch = JSON.stringify(arguments[1].optionRequest);

        //if (arguments[1].optionRequest === "filtersearchbegin") {
        if (arguments[1].optionRequest && arguments[1].optionRequest.startsWith("filter") === true && arguments[1].optionRequest !== "filterchoicerequest"  && arguments[1].optionRequest !== "filtering") {
                filterSearch = true;
          }
        else {
            filterSearch = false;
          }
        if (arguments[1].optionRequest  === "filterchoicerequest" || arguments[1].optionRequest  === "filtering") {
            arguments[1].optionRequest = "filter";
        }
        var out = (!filterSearch) ? { result: lastData  , count: original.totalreg, currentPage: original.pagina } : lastData;
        //arguments[1].filterSearch = false;

        return out;

        //incluir modificaciones aqui.
            //return { result: lastData  , count: original.totalreg, currentPage: original.pagina }
        //return { result: original.data  , count: original.totalreg, currentPage: original.pagina }

    }

    beforeSend (dm, request,settings) { 
        //debugger;
        if (settings.type==='DELETE')  {//(dm.dataSource.opcionRequest === 'delete') {

            settings.data = dm.dataSource.selectedData;
            settings.url = dm.dataSource.url;
            settings.options.url = dm.dataSource.url;
        } else
        if (settings.url.includes('datetime') === true) {
            
            let filtro = settings.url.split('$');
            let v_urlMod = '';
            filtro.map(key  => {
                if (key.search("filter=") === 0) {
                    key = key.replace(/ datetime'/g," '");
                    key = key.replace(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/g,"");
                    
                }
                if (v_urlMod === '') {
                    v_urlMod = key;
                } else {
                    v_urlMod = v_urlMod + '$' + key;
                }
                return true;
            })
            
            
            settings.url = v_urlMod;
            settings.options.url = v_urlMod;
            
        }

        //request.data.append('id_cosecha',8)
       /*  request.open ( 'GET' , 'UrlDatasource' );  // personalizando la URL de lHttpRequest                                   
        request.setRequestHeader ( 'Content-Type' , 'application / json' ); 
        dm.dataSource.headers = [{ "api-token": `${token}` }]; // configuración de encabezado      */
    }  

    processQuery (dm, query ) {
        
         var result = super.processQuery.apply(this, arguments); 
         //debugger;
         if ( (query.queries[0].e.predicates && query.queries[0].e.predicates.length > 0) || (query.queries[0].e.isComplex === false) ) {
             //dm.requestType === "filtering") {
            let v_query;
            if (query.queries[0].e.isComplex === false) {
                v_query = []
                v_query.push(query.queries[0].e);
            } else{
                v_query = query.queries[0].e.predicates;
            }
            
            if (result.url.includes('filter=') === true) {
                let v_urlArray = result.url.split('$');
                let v_urlMod = '';
                
                v_urlArray.map(key  => {
                    let filtro = ''
                    if (key.search("filter=") === 0) {
                        let v_condition ='';
                        if (query.queries[0].e.condition) {
                            v_condition = query.queries[0].e.condition
                        }
                        filtro = this.filterConstruct(v_query,v_condition,'');
                        
                        /* key = key.replace(/ datetime'/g," '");
                        v_posHor = key.search(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/)
                        key = key.replace(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/," "+key.substr(v_posHor+1,8));
                        v_posHor = key.search(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/)
                        key = key.replace(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/," "+key.substr(v_posHor+1,8)); */
                        //debugger;
                        if (filtro !== '') {
                            key = 'filter=('+filtro+')&'
                        } 
                        
                    }
                    if (v_urlMod === '') {
                        v_urlMod = key;
                    } else {
                        v_urlMod = v_urlMod + '$' + key;
                    }
                    return true;
                })
                result.url = v_urlMod;
                //settings.options.url = v_urlMod;
                
            } else {
                result.url = result.url.replace(/tolower/g,"lower");
            }
        }
        /* var tmp = JSON.parse(result.data); 
        var vars = this.getVariables() || {}; 
        vars['datamanager'] = tmp; 
        var data = JSON.stringify({ 
            query: this.getQuery(), 
            variables: vars 
        }); 
        result.data = data;  */
        return result;
    }

    filterConstruct (v_query,p_condition,filtro) {
        //let filtro
        //debugger;
        v_query.map(keyQ => {
            let v_condition = keyQ.condition;
            let v_operator;
            if (keyQ.isComplex === true) {
                filtro = '('+this.filterConstruct(keyQ.predicates,v_condition,filtro)+')';
                
            } else {
                if (keyQ.operator === "greaterthan") {
                    v_operator = 'gt'
                } else if (keyQ.operator === "lessthan") {
                    v_operator =  'lt'
                } else if (keyQ.operator === "equal") {
                    v_operator = 'eq'
                } else if (keyQ.operator === "notequal") {
                    v_operator = 'ne'
                } else if (keyQ.operator === "greaterthanorequal" ) {
                    v_operator = 'ge'
                } else if (keyQ.operator === "lessthanorequal" ) {
                    v_operator = 'le'
                } /* else if (keyQ.operator === "contains" || keyQ.operator === "startswith") {
                    v_operator = 'like';
                } */

                let validDate;
                let v_value;
                let v_tolower = "";
                let v_valueType = typeof keyQ.value;
                if (Object.prototype.toString.call(keyQ.value) === "[object Date]") {
                    if (isNaN(keyQ.value.getTime())) {  // d.valueOf() could also work
                      validDate = false;
                    } else {
                        validDate = true;
                    }
                } else {
                    validDate = false;
                }
                if (validDate === true) {
                    var dateObject = keyQ.value; 
                    v_value = 
                                    dateObject.getFullYear() +
                                    "/" + 
                                    (dateObject.getMonth()+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}) + 
                                    "/" + 
                                    dateObject.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                    + " " + dateObject.getHours().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                    + ":" +
                                    dateObject.getMinutes().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                    + ":" +
                                    dateObject.getSeconds().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
                } else if ( keyQ.ignoreCase === true && v_valueType !== 'number'){
                    v_value = keyQ.value.toLowerCase();
                    v_tolower = "tolower"
                } else {
                    v_value = keyQ.value;
                    v_tolower = ""
                };

               
                if (keyQ.operator === "contains") {
                    //v_value = "substringof('" + keyQ.value + "',tolower(" + keyQ.field + '))';
                    v_value = ' (' + v_tolower + '(' + keyQ.field + ") like '%" + v_value + "%')"
                } else if (keyQ.operator === "startswith") {
                    //v_value = 'startswith(tolower(' + keyQ.field + "),'" + keyQ.value + "')";
                    v_value = ' (' + v_tolower + '(' + keyQ.field + ") like '" + v_value + "%')"
                } else if (keyQ.operator === "endswith") {
                    //v_value = 'endswith(tolower(' + keyQ.field + "),'" + keyQ.value + "')";
                    v_value = ' (' + v_tolower + '(' + keyQ.field + ") like '%" + v_value + "')"
                } else {
                    v_value = ' (' + v_tolower + '(' + keyQ.field + ') ' + v_operator + " '" + v_value + "')";
                }
                if (filtro === '') {
                    //filtro = '(' + keyQ.field + ' ' + v_operator + " '" + v_value + "')";
                    filtro = v_value;
                } else {
                    //filtro = filtro + ' '+p_condition+' (' + keyQ.field + ' ' + v_operator + " '" + v_value + "')";
                    filtro = filtro + ' ' + p_condition + v_value;
                }
            }
            return true;
        })
        /* key = key.replace(/ datetime'/g," '");
        v_posHor = key.search(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/)
        key = key.replace(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/," "+key.substr(v_posHor+1,8));
        v_posHor = key.search(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/)
        key = key.replace(/T[0-9][0-9]:[0-9][0-9]:[0-9][0-9].[0-9][0-9][0-9]Z/," "+key.substr(v_posHor+1,8)); */
        //debugger;
        return filtro;
        /* if (filtro !== '') {
            key = 'filter=('+filtro+')&'
        }  */
     
    }
} 
/* processQuery (dm, query) {
        
    var result = super.processQuery.apply(this, arguments); 
    debugger;
    if ( query.queries[0].e.predicates && query.queries[0].e.predicates.length > 0 ) {
        //dm.requestType === "filtering") {
       let v_query = query.queries[0].e.predicates;
       if (result.url.includes('datetime') === true) {
           let v_urlArray = result.url.split('$');
           let v_urlMod = '';
           
           v_urlArray.map(key  => {
               let filtro = ''
               if (key.search("filter=") === 0) {
                   v_query.map(keyQ => {
                       let v_condition = keyQ.condition;
                       let v_operator;
                       if (keyQ.isComplex === true) {
                           keyQ.predicates.map(keyP => {
                               if (keyP.operator === "greaterthan") {
                                   v_operator = 'gt'
                               } else if (keyP.operator === "lessthan") {
                                   v_operator =  'lt'
                               } else if (keyP.operator === "equal") {
                                   v_operator = 'eq'
                               } else if (keyP.operator === "greaterthanorequal" ) {
                                   v_operator = 'ge'
                               } else if (keyP.operator === "lessthanorequal" ) {
                                   v_operator = 'le'
                               }
                               var dateObject = keyP.value; 
                               var v_date = 
                                           dateObject.getFullYear() +
                                           "/" + 
                                           (dateObject.getMonth()+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}) + 
                                           "/" + 
                                           dateObject.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                           + " " + dateObject.getHours().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                           + ":" +
                                           dateObject.getMinutes().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                           + ":" +
                                           dateObject.getSeconds().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
                               if (filtro === '') {
                                   filtro = filtro + '(' + keyP.field + ' ' + v_operator + " '" + v_date + "')"
                               } else {
                                   filtro = filtro + ' ' + v_condition + ' (' + keyP.field + ' ' + v_operator + " '" + v_date + "')"
                               }
                               return true;
                           });
                       } else {
                           if (keyQ.operator === "greaterthan") {
                               v_operator = 'gt'
                           } else if (keyQ.operator === "lessthan") {
                               v_operator =  'lt'
                           } else if (keyQ.operator === "equal") {
                               v_operator = 'eq'
                           } else if (keyQ.operator === "greaterthanorequal" ) {
                               v_operator = 'ge'
                           } else if (keyQ.operator === "lessthanorequal" ) {
                               v_operator = 'le'
                           }
                           var dateObject = keyQ.value; 
                           var v_date = 
                                           dateObject.getFullYear() +
                                           "/" + 
                                           (dateObject.getMonth()+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}) + 
                                           "/" + 
                                           dateObject.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                           + " " + dateObject.getHours().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                           + ":" +
                                           dateObject.getMinutes().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
                                           + ":" +
                                           dateObject.getSeconds().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
                           if (filtro === '') {
                               filtro = filtro + '(' + keyQ.field + ' ' + v_operator + " '" + v_date + "')"
                           } 
                       }
                       return true;
                   })
                   
                   debugger;
                   if (filtro !== '') {
                       key = 'filter=('+filtro+')&'
                   } 
                   
               }
               if (v_urlMod === '') {
                   v_urlMod = key;
               } else {
                   v_urlMod = v_urlMod + '$' + key;
               }
               return true;
           })
           result.url = v_urlMod;
           //settings.options.url = v_urlMod;
           
       } else {
           result.url = result.url.replace(/tolower/g,"lower");
       }
   }
   
   return result;
} */